import axios from 'axios';
const API_URL = process.env.REACT_APP_API_URL;

const TypeAnnoncePercentagesService = {
  savePercentages: async (percentages: any) => {
    return axios.post(`${API_URL}/type-annonce-percentages`, { percentages });
  },

  getPercentages: async () => {
    return await axios.get(`${API_URL}/type-annonce-percentages`);
  },

  getPercentageForNSType: async (nSType: number) => {
    const resp = await TypeAnnoncePercentagesService.getPercentages();
    if (!resp?.data) return 0;
    const row = resp.data.find((item: any) => Number(item.nSType) === Number(nSType));
    return row ? row.discountPercentage || 0 : 0;
  }
};

export default TypeAnnoncePercentagesService;
